import * as RDD from 'react-device-detect';
import { RDD_LABELS } from '../utils/deviceDetectUtils';
export function getRDDResult() {
    const rddResult = {};
    Object.keys(RDD_LABELS).forEach((rddKeyStr) => {
        const rddKey = rddKeyStr;
        const selectorResult = RDD[rddKey];
        rddResult[rddKey] = selectorResult;
    });
    return rddResult;
}
